import { render, staticRenderFns } from "./ModalComplementosDesacumulados.vue?vue&type=template&id=d3115eb6&scoped=true&style=border-radius%3A%2010px&"
import script from "./ModalComplementosDesacumulados.vue?vue&type=script&lang=js&"
export * from "./ModalComplementosDesacumulados.vue?vue&type=script&lang=js&"
import style0 from "./ModalComplementosDesacumulados.vue?vue&type=style&index=0&id=d3115eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3115eb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VCard,VCol,VDivider,VIcon,VImg,VRow,VSwitch,VTextarea,VTooltip})
